import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginLeft: '8px',
    '& .MuiSvgIcon-root': { marginRight: '0px' },
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  dialogActions: {
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '16px 24px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginTop: '1rem',
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  row: {
    display: 'flex',
    gap: '16px',
  },
  halfCol: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  fileSize: {
    marginTop: '8px',
  },
  uploadContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  dropzoneDefault: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '3rem 4rem',
    borderWidth: '2px',
    borderStyle: 'dashed',
    borderColor: '#6CB4DB',
    borderRadius: '4px'
  },
  dropzoneActive: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '3rem 4rem',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: '#0FAC9B',
    background: '#C9EDE8',
    borderRadius: '4px'
  },
  dropzoneReject: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '3rem 4rem',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: '#D25A41',
    background: '#FADEDA',
    borderRadius: '4px'
  }
});
